import {
  IOccupationCard,
  OccupationCategory
} from '@cpd-app/core-module/models';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export const occupationCardsFeatureKey = 'occupationCards';

export const occupationCardsStateAdapter: EntityAdapter<OccupationCategory> =
  createEntityAdapter<OccupationCategory>({
    selectId: (occupationCategory: OccupationCategory) =>
      occupationCategory.name,
    sortComparer: false
  });

export interface OccupationCardsState extends EntityState<OccupationCategory> {
  loading: boolean;
  occupationCards: IOccupationCard[];
}

export const initialOccupationCardsState: OccupationCardsState =
  occupationCardsStateAdapter.getInitialState({
    loading: false,
    occupationCards: []
  });

export const { selectAll, selectEntities, selectIds, selectTotal } =
  occupationCardsStateAdapter.getSelectors();
